module.exports = __webpack_public_path__ + "static/verify-email-shop-view-c961bf4fbb12a4e7c4a9f73c52793abe.png";